import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Mail, X, Loader2 } from 'lucide-react';
import api from '@/lib/api';

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);

  // Don't show if user is verified, not logged in, or banner dismissed
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setResending(true);
    try {
      await api.post('/auth/resend-verification', { email: user.email });
      toast.success('Email de verificação enviado!');
    } catch (error) {
      toast.error('Erro ao enviar email. Tenta novamente mais tarde.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div 
      className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-lg p-4 mb-4"
      data-testid="email-verification-banner"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center">
          <Mail className="w-5 h-5 text-amber-500" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground text-sm">
            Verifica o teu email
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Enviámos um email de verificação para <strong className="text-foreground">{user.email}</strong>. 
            Verifica a tua caixa de entrada para ativar todas as funcionalidades.
          </p>
          
          <div className="flex items-center gap-3 mt-3">
            <Button
              size="sm"
              variant="outline"
              onClick={handleResend}
              disabled={resending}
              className="text-xs border-amber-500/50 hover:bg-amber-500/10"
            >
              {resending ? (
                <>
                  <Loader2 className="w-3 h-3 mr-2 animate-spin" />
                  A enviar...
                </>
              ) : (
                'Reenviar email'
              )}
            </Button>
          </div>
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setDismissed(true)}
          className="flex-shrink-0 h-8 w-8"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
